// extracted by mini-css-extract-plugin
export var formContainer = "_ku-0";
export var message = "_ku-1";